import { useEffect } from "react";
import MileStone from "./International/MileStone";
import Mission from "./Mission";

const About = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );
  return (
    <div>
      <div className="aboutus-image">
        <img src="/new-image/aboutUs.jpg" alt="" className="w-[100%]" />
      </div>

      <div className="flex flex-col justify-center text-justify  gap-4 max-w-[50rem] mx-auto  pt-[2rem] pb-[.1rem] px-[2rem]">
        <p>
          Back in 1983, when TCS started off with just 25 shipments on its first
          day, there was no doubt that it would grow to become the leader in
          Pakistan’s courier industry. Since then, TCS has moved from being a
          courier service provider to become a time-honoured, tested and proven
          name for delivering a wide range of logistics services. Not just that,
          but TCS is now on its way to becoming the logistics backbone of the
          country—much more than just a humble courier company.
        </p>
        <p>
          While It is easy to take TCS for a technology-driven company, at the
          heart of the TCS phenomena of success are the people. Those, who do
          not forget that the customers are the only catalysts of change, and
          that the strategic insights about the business and the customers is
          the only true guide which makes it possible to achieve the high
          standards of service.
        </p>
        <p>
          Our propensity to get the most out of modern technologies does not
          only help us to develop tailor-made products and services, it allows
          us to maintain industry-transforming standards which become the
          benchmarks that others aspire to achieve. We reaffirm our commitment
          to doing better for our customers everyday by providing exciting new
          possibilities and to continue to be your first choice. Today,
          tomorrow, always.
        </p>

        <div className="flex">
          <div className="flex-1 flex flex-col">
            {/* <div className="">
                                <li><Link to="/about/mission"  className='font-bold'>Mission & Core Values</Link></li>
                            </div> */}
          </div>

          <div className="flex-1 flex flex-col">
            {/* <div className="flex items-center">
                                <li><Link to="/about/mile-stone" className='font-bold'>MileStone</Link></li>
                            </div> */}
          </div>
        </div>
      </div>
      <div id="mission">
        <Mission />
      </div>
      <div id="mile-stone">
        <MileStone />
      </div>
    </div>
  );
};

export default About;
